import React, { useRef } from 'react';
import { Button, Tab, Tabs } from '@material-ui/core';
import { t } from '@lingui/macro';
import { useSearchParams } from 'react-router-dom';

import AdminPage from '../AdminPage';
import { useIsIpmDisabled } from '../../../stores/EnvironmentStore';
import Actions from '../../page-framework/actions/Actions';
import { buildPageId, AdminPages } from '../AdminLinkUtils';
import {
    THRESHOLDS_QUERY_KEY_TYPE,
    THRESHOLDS_TAB_INFRA,
    THRESHOLDS_TAB_SERVICE,
    DEFAULT_SERVICE_GROUP,
} from './ThresholdsConstants';
import ThresholdsInfrastructureTab from './ThresholdsInfrastructureTab';
import ThresholdsServiceTab from './ThresholdsServiceTab';

export default function ThresholdsAdminPage() {
    const [searchParams, setSearchParams] = useSearchParams();
    const initialServiceType = (searchParams.get(THRESHOLDS_QUERY_KEY_TYPE) || '').trim();
    const tab = initialServiceType ? THRESHOLDS_TAB_SERVICE : THRESHOLDS_TAB_INFRA;

    const infrastructureRef = useRef(null);
    const serviceRef = useRef(null);
    const [isIpmDisabled] = useIsIpmDisabled();

    const onSave = async () => {
        if (tab === THRESHOLDS_TAB_INFRA) {
            await infrastructureRef.current?.save();
        } else {
            await serviceRef.current?.save();
        }
    };

    const handleTabChange = (event, newTab) => {
        if (newTab === tab) {
            return;
        }

        const nextSearchParams = new URLSearchParams(searchParams);
        if (newTab === THRESHOLDS_TAB_INFRA) {
            nextSearchParams.delete(THRESHOLDS_QUERY_KEY_TYPE);
        } else {
            nextSearchParams.set(THRESHOLDS_QUERY_KEY_TYPE, DEFAULT_SERVICE_GROUP);
        }
        setSearchParams(nextSearchParams);
    };

    return (
        <AdminPage
            title={t`Thresholds`}
            pageId={buildPageId(AdminPages.Thresholds)}
            actions={
                <Actions>
                    <Button onClick={onSave} variant="contained" color="primary">
                        {t`Save`}
                    </Button>
                </Actions>
            }
        >
            <>
                <Tabs value={tab} onChange={handleTabChange}>
                    {!isIpmDisabled && <Tab value={THRESHOLDS_TAB_INFRA} label={t`Infrastructure`} />}
                    <Tab value={THRESHOLDS_TAB_SERVICE} label={t`Service Test`} />
                </Tabs>

                {tab === THRESHOLDS_TAB_INFRA && <ThresholdsInfrastructureTab ref={infrastructureRef} />}
                {tab === THRESHOLDS_TAB_SERVICE && (
                    <ThresholdsServiceTab ref={serviceRef} initialServiceGroup={initialServiceType} />
                )}
            </>
        </AdminPage>
    );
}
